import { useRef, useState, useEffect } from 'react'
import { useWindowSize, useEffectOnce } from 'react-use'
import useAnimationFrame from '@phntms/use-animation-frame'
import innerHeight from 'ios-inner-height'
import SketchBalls from '../libs/sketch'
import { useBackgroundThemeContext } from '../providers/BackgroundThemeProvider'

const textures = [
  '/static/img/matcap0.webp',
  '/static/img/matcap1.webp',
  '/static/img/matcap2.webp',
  '/static/img/matcap3.webp'
]

function Sketch() {
  const index = useBackgroundThemeContext()
  const [screenHeight, setScreenHeight] = useState(innerHeight())
  const mountRef = useRef(null)
  const instanceRef = useRef(null)
  const firstPaintTimerRef = useRef(null)
  const { width, height } = useWindowSize()

  useEffectOnce(() => {
    ;(async () => {
      instanceRef.current = new SketchBalls({
        dom: mountRef.current,
        textures: textures
      })
      await instanceRef.current.load()

      firstPaintTimerRef.current = setTimeout(() => {
        instanceRef.current.init(index)
      }, 400);
    })()

    return () => {
      clearTimeout(firstPaintTimerRef.current)
      instanceRef.current.destroy()
    }
  })

  useAnimationFrame(() => {
    if(!instanceRef.current || !instanceRef.current.loaded)
      return

    instanceRef.current.render()
  })

  useEffect(() => {
    if (!instanceRef.current) return
    instanceRef.current.updateTexture(index)
  }, [index])

  useEffect(() => {
    setScreenHeight(innerHeight())
    if (!instanceRef.current) return
    instanceRef.current.resize()
  }, [width, height])

  return (
    <div className="pointer-events-none">
      <div
        className="w-full fixed inset-0 z-10"
        ref={mountRef}
        style={{ minHeight: `${screenHeight}px` }}
      ></div>
      <div
        className="w-full fixed inset-0 z-10 bg-black/10"
        style={{ minHeight: `${screenHeight}px` }}
      ></div>
    </div>
  )
}

export default Sketch
